<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>


<!------------------------------

    Side Panel

------------------------------->


<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'nav.network.mediumTransformations' | translate}}"
  [itemsData]="transformations"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'transformations'">

  <!------------------------------

      Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>


  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.description' | translate }}
      </th>
      <th>
        {{ 'lang.globals.command' | translate }}
      </th>
      <th>
        {{ 'lang.globals.created' | translate }}
      </th>
      <th class=" sticky-col last-col tw-z-20">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-transformation>

    <tr>
      <td>
        {{ transformation?.id }}
      </td>
      <td>
        <span [innerHTML]="transformation?.name |truncate:20"></span>
      </td>
      <td>
        <span [innerHTML]="transformation?.description |truncate:30"></span>
      </td>
      <td>
        {{ transformation?.command }}
      </td>
      <td>
        <sb-comp-display-created [data]="transformation"></sb-comp-display-created>
      </td>
      <td class="tr bw sticky-col last-col">
        @if (isInModalContext) {
          <button sb-button-secondary
                  type="button"
                  ngbTooltip="{{'lang.globals.select' | translate}}"
                  (click)="selectTransformations(transformation)"
                  [icon]="'boxChecked'"
                  [color]="'blue'"
                  [iconButton]="true">
          </button>
        }
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
